// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"84":"common-ui","744":"actioncable"}[chunkId] + "-" + {"84":"88f235d5e8661f9aa423","744":"bfacd38bb0a1da87a076"}[chunkId] + ".chunk.js";
};